type Props = {
  /** コンポーネント内に表示される子要素。 */
  children: React.ReactNode;
};

/** ボーダー付きのコンテナコンポーネント。  */
export const BorderedContainer = ({ children }: Props) => {
  return (
    <div className="border border-outline rounded-[12px] px-[24px] py-[16px] bg-surface">
      {children}
    </div>
  );
};
